export default __webpack_public_path__ + "static/Single-9b28596b533afcd6b4d438a5faba4b2a.svg";